
import * as React from 'react';
import './Admin.less';
import { Form, Input, Button, Select, Divider, message, Spin, Checkbox, Tooltip, Col, Modal, InputNumber, Row } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import { withRouter, Link, Redirect } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';

import ActivityQuestionResponses from './ActivityQuestionResponses';
import { ActivityQuestionResponsesProps } from './ActivityQuestionResponses';
import TranslationDTO from 'src/models/generic/TranslationDTO';
import AddActivityQuestionDTO from 'src/models/activity/AddActivityQuestionDTO';
import UpdateActivityQuestionDTO from 'src/models/activity/UpdateActivityQuestionDTO';
import KeyValueListDTO from 'src/models/generic/KeyValueListDTO';
import KeyValueDTO from 'src/models/generic/KeyValueDTO';
import ActivityApiController from 'src/api/ActivityApiController';
import CultureApiController from 'src/api/CultureApiController';
import UpdateActivityDTO from 'src/models/activity/UpdateActivityDTO';
import TextArea from 'antd/lib/input/TextArea';
import ActivityQuestionTranslationDTO from '../../models/activity/ActivityQuestionTranslationDTO';
import Languages, { Language } from "src/constants/Languages";
import { GenericFormItem } from "src/utils/FormUtil";

interface RouteParams {
    activityId: string;
    activityQuestionId: string;
}

interface AddEditActivityQuestionProps extends PageProps<RouteParams>, LocalizeContextProps { }

interface AddEditActivityQuestionState {
    loading: boolean;
    visible: boolean;
    isSubmitting: boolean;
    categoryName: string;
    currentActivityQuestion: UpdateActivityQuestionDTO;
    allCultures: Language[];
    questionCategories: KeyValueDTO<string, number>[];
    selectedCultureId: number;
}

interface ActivityQuestionFormProps {
    currentActivityQuestion: UpdateActivityQuestionDTO;
    allCultures: Language[];
    questionCategories: KeyValueDTO<string, number>[];
    selectedCultureId: number;
    translate: (id: any) => any;
    onChange: (changedFields: any[]) => void;
}

// Form
let ActivityQuestionForm = Form.create({
    onFieldsChange(props: ActivityQuestionFormProps, changedFields: any[]) {
        props.onChange(changedFields);
    }
})(class extends React.Component<ActivityQuestionFormProps & FormComponentProps> {
    constructor(props: ActivityQuestionFormProps & FormComponentProps) {
        super(props);
    }

    private generateOptionsForSelect(keyValues: KeyValueDTO<string, number>[]): JSX.Element[] {
        return keyValues.map(keyValue => <Select.Option value={keyValue.value} key={keyValue.key} title={keyValue.key}>{keyValue.key}</Select.Option>);
    }

    private generateLanguageOptions() {
        // Only available languages
        return Languages.All.filter(x => x.isAvailable)
            .map(x => <Select.Option key={`cultureIds${x.id}`} value={x.id}>{x.name} ({x.code})</Select.Option>);
    }

    private renderQuestionTranslations(): JSX.Element[] {
        if (this.props.currentActivityQuestion) {
            let translations = this.props.currentActivityQuestion.translations;

            return translations.map((translation: ActivityQuestionTranslationDTO, index: number) => {
                let id = "questionText[" + index + "].text";
                // let cultureKey = this.props.allCultures.find(culture => culture.value === translation.cultureId).key.toLowerCase();
                let cultureKey = Languages.FindById(translation.cultureId).code.toLowerCase();
                let translationId = "admin.addEditActivityQuestion.question-" + cultureKey;

                return this.renderStandardFormItem(
                    translationId,
                    id,
                    translation.questionText,
                    <TextArea rows={4} autoComplete="off" />,
                    this.props.selectedCultureId === translation.cultureId
                );
            });
        }
    }

    private renderFeedbackTranslations(): JSX.Element[] {
        if (this.props.currentActivityQuestion) {
            let translations = this.props.currentActivityQuestion.translations;

            return translations.map((translation: ActivityQuestionTranslationDTO, index: number) => {
                let id = "feedbackText[" + index + "].text";
                let cultureKey = Languages.FindById(translation.cultureId).code.toLowerCase();
                let translationId = "admin.addEditActivityQuestion.feedback-" + cultureKey;

                return <GenericFormItem
                    form={this.props.form}
                    labelId={translationId}
                    id={id}
                    initialValue={translation.feedbackText}
                    required={false}
                    visible={this.props.selectedCultureId === translation.cultureId}>
                    <TextArea rows={4} autoComplete="off" />
                </GenericFormItem>;
            });
        }
    }

    private renderStandardFormItem(translationId: string, id: string, initialValue, inputType, visible: boolean = true, required: boolean = true) {
        let translatedLabel = this.props.translate(translationId);

        if (visible) {
            return (
                <Form.Item label={translatedLabel}>
                    {this.props.form.getFieldDecorator(id, {
                        initialValue: initialValue,
                        rules: [{ required: required, message: this.props.translate('admin.common.requiredRule') }]
                    })(inputType)}
                </Form.Item>
            );
        }
    }

    render() {
        return (
            <Row>
                <Col span={12}>
                    <Form className="admin-form">
                        {this.renderStandardFormItem(
                            "admin.addEditActivityQuestion.formItem1",
                            "selectedCultureId",
                            this.props.selectedCultureId,
                            <Select>{this.generateLanguageOptions()}</Select>
                        )}

                        {this.renderQuestionTranslations()}
                        {this.renderFeedbackTranslations()}

                        {this.renderStandardFormItem(
                            "admin.addEditActivityQuestion.formItem2",
                            "displayOrder",
                            this.props.currentActivityQuestion.displayOrder,
                            <InputNumber autoComplete="off" min={1} />
                        )}

                        {this.renderStandardFormItem(
                            "admin.addEditActivityQuestion.formItem3",
                            "activityQuestionCategoryId",
                            this.props.currentActivityQuestion.activityQuestionCategoryId,
                            <Select>{this.generateOptionsForSelect(this.props.questionCategories)}</Select>,
                            !this.props.currentActivityQuestion.isSurvey,
                            false
                        )}

                        {this.renderStandardFormItem(
                            "admin.addEditActivityQuestion.formItem4",
                            "enableMultipleSelection",
                            this.props.currentActivityQuestion.enableMultipleSelection,
                            <Checkbox checked={this.props.currentActivityQuestion.enableMultipleSelection} />,
                            !this.props.currentActivityQuestion.isSurvey,
                            false
                        )}
                    </Form>
                </Col>
            </Row>
        );
    }
});

class AddEditActivityQuestion extends React.Component<AddEditActivityQuestionProps, AddEditActivityQuestionState> {
    private formRef: React.Component<FormComponentProps>;

    constructor(props: AddEditActivityQuestionProps) {
        super(props);
        bindAllOfThis(this, AddEditActivityQuestion.prototype);

        let activityId = parseInt(this.props.match.params.activityId, 10);
        let activityQuestionId = parseInt(this.props.match.params.activityQuestionId, 10);

        let currentActivityQuestion: UpdateActivityQuestionDTO = {
            activityQuestionId: activityQuestionId,
            activityId: activityId,
            activityQuestionCategoryId: null,
            translations: [],
            enableMultipleSelection: false,
            displayOrder: null,
            isSurvey: false
        };

        this.state = {
            loading: true,
            visible: false,
            isSubmitting: false,
            categoryName: "",
            allCultures: [],
            questionCategories: [],
            selectedCultureId: 0,
            currentActivityQuestion: currentActivityQuestion
        };
    }

    componentWillMount(): void {
        let categoriesPromise = ActivityApiController.getActivityQuestionCategories(this.state.currentActivityQuestion.activityId);
        let cultures = Languages.All.filter((l) => l.isAvailable);

        categoriesPromise.then(result => {
            let categories = result.data;

            this.setState({
                questionCategories: categories.keyValues,
                allCultures: cultures,
                selectedCultureId: cultures[0].id
            }, this.fillForm);
        });
    }

    private fillForm(): void {
        if (this.state.currentActivityQuestion.activityQuestionId) {
            ActivityApiController.getActivityQuestion(this.state.currentActivityQuestion.activityQuestionId).then((result) => {
                this.setState({
                    loading: false,
                    currentActivityQuestion: result.data
                });
            }).catch(e => {
                message.error(this.props.translate('admin.addEditActivityQuestion.messageRetrieveError'));
            });
        } else {
            ActivityApiController.getActivity(this.state.currentActivityQuestion.activityId).then((result) => {
                let translations = this.state.allCultures.map(
                    (culture: Language): ActivityQuestionTranslationDTO => {
                        let translation: ActivityQuestionTranslationDTO = {
                            cultureId: culture.id,
                            questionText: null,
                            feedbackText: null
                        };

                        return translation;
                    }
                );

                let activityQuestion = {
                    translations: translations,
                    isSurvey: result.data.isSurvey
                } as UpdateActivityQuestionDTO;

                this.setState({
                    currentActivityQuestion: { ...this.state.currentActivityQuestion, ...activityQuestion },
                    loading: false
                });
            });
        }
    }

    private translationsAreCompleted(): boolean {
        let translations = this.state.currentActivityQuestion.translations;
        let emptyTranslations = translations.filter(translation =>
            translation.questionText === null || translation.questionText === ""
        );

        return emptyTranslations.length === 0;
    }

    private handleInputChange(changedFields: any[]): void {
        let newState = {};
        for (var key in changedFields) {
            if (changedFields.hasOwnProperty(key)) {
                let field: any = changedFields[key];

                // If key is the nested property
                if (key === 'feedbackText' || key === 'questionText') {
                    let fieldKey = '';
                    let localizedTextKey = 'translations';
                    for (var fieldName in field) {
                        if (field.hasOwnProperty(fieldName)) {
                            fieldKey = fieldName;
                            break;
                        }
                    }

                    newState[localizedTextKey] = [...this.state.currentActivityQuestion.translations];
                    newState[localizedTextKey][fieldKey][key] = field[fieldKey].text.value;
                } else if (key === 'selectedCultureId') {
                    this.setState({ selectedCultureId: field.value });
                    return;
                } else {
                    newState[key] = field.value;
                }
            }
        }
        this.setState({
            currentActivityQuestion: { ...this.state.currentActivityQuestion, ...newState }
        });
    }

    private addActivityQuestion(): void {
        let addActivityQuestionDTO: AddActivityQuestionDTO = {
            displayOrder: this.state.currentActivityQuestion.displayOrder,
            activityQuestionCategoryId: this.state.currentActivityQuestion.activityQuestionCategoryId,
            translations: this.state.currentActivityQuestion.translations,
            activityId: this.state.currentActivityQuestion.activityId,
            enableMultipleSelection: this.state.currentActivityQuestion.enableMultipleSelection
        };

        ActivityApiController.addActivityQuestion(addActivityQuestionDTO)
            .then(result => {
                message.success(this.props.translate('admin.addEditActivityQuestion.messageAdd'));
                this.setState({ isSubmitting: false });
                this.props.history.push(Routes.getRoute(Routes.ADMIN_ADD_EDIT_ACTIVITY_QUESTION, this.state.currentActivityQuestion.activityId, result.data));
            }).catch(e => {
                message.error(this.props.translate('admin.addEditActivityQuestion.messageAddError'));
                this.setState({ isSubmitting: false });
            });
    }

    private updateActivityQuestion(): void {
        ActivityApiController.updateActivityQuestion(this.state.currentActivityQuestion)
            .then(result => {
                message.success(this.props.translate('admin.addEditActivityQuestion.messageUpdate'));
                this.setState({ isSubmitting: false });
                this.props.history.push(Routes.getRoute(Routes.ADMIN_ADD_EDIT_ACTIVITY_QUESTION, this.state.currentActivityQuestion.activityId, this.state.currentActivityQuestion.activityQuestionId));
            }).catch(e => {
                message.error(this.props.translate('admin.addEditActivityQuestion.messageUpdateError'));
                this.setState({ isSubmitting: false });
            });
    }

    private handleSubmit(e): void {
        e.preventDefault();

        this.formRef.props.form.validateFields((error: any, values: any) => {
            if (!error) {
                this.setState({ isSubmitting: true });
                this.state.currentActivityQuestion.activityQuestionId ? this.updateActivityQuestion() : this.addActivityQuestion();
            }
        });
    }

    private handleCancel(e): void {
        this.props.history.push(Routes.getRoute(Routes.ADMIN_ADD_EDIT_ACTIVITY, this.state.currentActivityQuestion.activityId));
    }

    private renderSaveButton(): JSX.Element {
        if (this.translationsAreCompleted()) {
            return (
                <Button type="primary" onClick={this.handleSubmit} loading={this.state.isSubmitting}>
                    <Translate id="admin.common.saveButton" />
                </Button>
            );
        }

        return (
            <Tooltip placement="bottom" title={this.props.translate('admin.addEditActivityQuestion.saveTooltip')} arrowPointAtCenter>
                <Button type="primary" disabled>
                    <Translate id="admin.common.saveButton" />
                </Button>
            </Tooltip>
        );
    }

    private renderActivityQuestionResponses(): JSX.Element {
        let datatableProps = {
            activityId: this.state.currentActivityQuestion.activityId,
            activityQuestionId: this.state.currentActivityQuestion.activityQuestionId,
            isSurvey: this.state.currentActivityQuestion.isSurvey
        } as ActivityQuestionResponsesProps;

        if (this.state.currentActivityQuestion.activityQuestionId) {
            return < ActivityQuestionResponses {...datatableProps} />;
        }
    }

    render() {
        if (this.state.loading) {
            return <Spin />;
        }

        let formProps = {
            currentActivityQuestion: this.state.currentActivityQuestion,
            allCultures: this.state.allCultures,
            questionCategories: this.state.questionCategories,
            selectedCultureId: this.state.selectedCultureId,
            translate: this.props.translate,
            onChange: this.handleInputChange
        } as ActivityQuestionFormProps;

        return (
            <div>
                <h2>
                    <Translate id="admin.addEditActivityQuestion.addHeader" />
                </h2>

                <ActivityQuestionForm wrappedComponentRef={ref => this.formRef = ref} {...formProps} />

                <div>
                    {this.renderSaveButton()}
                    <Divider type="vertical" />
                    <Button onClick={this.handleCancel}>
                        <Translate id="common.back" />
                    </Button>
                </div>

                <br /><br />

                {this.renderActivityQuestionResponses()}

            </div>
        );
    }
}

export default withLocalize(AddEditActivityQuestion);



// WEBPACK FOOTER //
// ./src/pages/admin/AddEditActivityQuestion.tsx